export default __webpack_public_path__ + "static/media/Gift.2b033b94.svg";